import React, { useState, useEffect, useContext, useMemo } from "react";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form, FormControl, Button } from "react-bootstrap";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import MyContext from "../../../MyContext";
import "../AdminDashboard.css"
import NoIndex from "../../NoIndex";
import rightArrow from "../../../images/Arrow - Right.svg";
import downArrow from "../../../images/Arrow - Down.svg";
import {
  ToggleButton,
  ToggleButtonGroup,
  Modal,
  Table,
} from "react-bootstrap";
import abank from "../../../images/Bank IMG.svg";
function AdminOrdersSetting({ Admin }) {
  const [userID, setuserID] = useState('')
  const [loading, setLoading] = useState(false);
  const { baseUrl } = useContext(MyContext);
  const { config } = useContext(MyContext);
  const [ClientName, setClientName] = useState('')
  const [Clients, setClients] = useState([]);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);

  const [currentCatalogueStatus, setCurrentCatalogueStatus] = useState("");

  // Discount Payload

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (error) => {
          console.error('Error getting location:', error);
        }
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
    }
  }, []);

  function HandleClientChange({ code, name }) {
    setuserID(code);
    setClientName(name)

  }


  const FetchClientCall = async () => {
    setLoading(true);
    try {

      const UserDetail = {
        // userid: User.pkid,
        userid: Admin.pkid,
        latitude: latitude,
        longitude: longitude,
      };

      const response = await axios.post(
        `${baseUrl}/api/Admin/getAllClientList`,
        UserDetail,
        config
      );
      if (response.data.responseCode === "00") {
        // toast.success(response.data.responseMessage);

        setClients(response.data.response);

        setLoading(false);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("error");
      console.error("Error updating Admin login:", error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    FetchClientCall();
  }, []);
  const catalogueStatusApi = async () => {
    try {
      const requestBody = {
        userid: userID,
      };
      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/getCatalogueStatus`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        setCurrentCatalogueStatus(response.data.response.catalogueStatus);
      } else {
      }
    } catch { }
  };
  const catalogueONOFFApi = async (command) => {
    try {
      setCurrentCatalogueStatus(command);

      const requestBody = {
        userid: userID,
        secret: "string",
        status: command,
      };
      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/changeCatalogueStatus`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        Swal.fire({
          title: "Success",
          text: response.data.responseMessage,
          icon: "success",
          confirmButtonText: "Okay",
        });
        catalogueStatusApi();
      } else {
        Swal.fire({
          title: "Error",
          text: "Something went wrong.",
          icon: "error",
          confirmButtonText: "Okay",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "An error occurred while processing your request.",
        icon: "error",
        confirmButtonText: "Okay",
      });
    }
  };
  const handleToggle = () => {
    if (currentCatalogueStatus === "hide") {
      catalogueONOFFApi("show");
    } else {
      catalogueONOFFApi("hide");
    }
  };
  useEffect(() => {
    catalogueStatusApi();
  }, [userID]);


  // client order setting


  const [activeTab, setActiveTab] = useState("deliveryCharges");

  const [chargesData, setChargesData] = useState([]);
  const [settlementData, setSettlementData] = useState([]);
  const [discountsData, setDiscountsData] = useState([]);
  const [couponData, setCouponData] = useState([]);
  const [loyaltyPointsData, setLoyaltyPointsData] = useState([]);
  const [timingData, setTimingData] = useState([]);
  const [selectedFreeItem, setSelectedFreeItem] = useState("");

  const [searchText, setSearchText] = useState("");
  const [expandedCategories, setExpandedCategories] = useState([]);
  const [deliveryData, setDeliveryData] = useState({
    userid: "",
    charges: "",
    fromAmount: "",
    toAmount: "",
    chargeType: "",
  });

  // Discount Payload
  const [discountData, setDiscountData] = useState({
    userid: "",
    discount: "",
    fromAmount: "",
    toAmount: "",
    discountType: "",
    orderType: "",
    maxDiscount: "",
  });

  const [newCouponData, setNewCouponData] = useState({
    couponCode: "",
    discount: "",
    discountType: "",
    minOrderAmount: "",
    maxDiscountAmount: "",
    couponTitle: "",
    couponDiscription: "",
  });
  const [updateLoyaltyPointsData, setUpdateLoyaltyPointsData] = useState({
    points: "",
    value: "",
  });
  const [freeItemData, setFreeItemData] = useState({
    minAmount: "",
    singleUse: "",
  });


  const [updateOrderTimingData, setUpdateOrderTimingData] = useState({
    opening: "",
    closing: "",
    weekOff: "",
  });
  const [printSettingData, setPrintSettingData] = useState({
    normalFontSize: "",
    largeFontSize: "",
    pageWidth: "",
    anlookActive: false,
    autoPrint: false
  });
  const [specialOffers, setSpecialOffers] = useState([]);
  const [newSpecialOffer, setNewSpecialOffer] = useState({
    customerMobile: "",
    offerType: "",
  });

  const [printSettingDetails, setPrintSettingDetails] = useState(null);
  const [serviceData, setServiceData] = useState([]);
  const isEmptyOrWhitespace = (value) => !value || !value.trim();
  const isNumber = (value) => !isNaN(value) && value.trim() !== "";
  const handleDeliveryChange = (e) => {
    setDeliveryData({ ...deliveryData, [e.target.name]: e.target.value });
  };
  const handlePrintSettingChange = (e) => {
    const { name, value, type, checked } = e.target;

    setPrintSettingData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleDiscountChange = (e) => {
    setDiscountData({ ...discountData, [e.target.name]: e.target.value });
  };
  const handleNewCouponChange = (e) => {
    setNewCouponData({ ...newCouponData, [e.target.name]: e.target.value });
  };
  const handleUpdateDeliveryCharges = async () => {
    const { charges, fromAmount, toAmount, chargeType } = deliveryData;

    if (
      isEmptyOrWhitespace(userID) ||
      isEmptyOrWhitespace(charges) ||
      !isNumber(charges) ||
      isEmptyOrWhitespace(fromAmount) ||
      !isNumber(fromAmount) ||
      isEmptyOrWhitespace(toAmount) ||
      !isNumber(toAmount) ||
      isEmptyOrWhitespace(chargeType)
    ) {
      toast.error(
        " Please fill all fields correctly. Charges and Amounts must be numeric."
      );
      return;
    }

    setLoading(true);
    try {
      const requestBody = {
        userid: userID.trim(),
        charges: charges.trim(),
        fromAmount: fromAmount.trim(),
        toAmount: toAmount.trim(),
        chargeType: chargeType.trim(),
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateDeliveryCharges`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          ` ${response?.data?.responseMessage ||
          "Delivery charges updated successfully."
          }`
        );

        // Reset deliveryData
        setDeliveryData({
          userid: "",
          charges: "",
          fromAmount: "",
          toAmount: "",
          chargeType: "",
        });
        getChargesApi();
      } else {
        toast.error(
          ` ${response?.data?.responseMessage ||
          "Failed to update delivery charges."
          }`
        );
      }
    } catch (error) {
      // toast.error(" Error updating delivery charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleOrderTimingChange = (e) => {
    setUpdateOrderTimingData({
      ...updateOrderTimingData,
      [e.target.name]: e.target.value,
    });
  };
  const handleUpdateDiscount = async () => {
    const {
      discount,
      fromAmount,
      toAmount,
      discountType,
      orderType,
      maxDiscount,
    } = discountData;

    if (
      isEmptyOrWhitespace(userID) ||
      isEmptyOrWhitespace(discount) ||
      !isNumber(discount) ||
      isEmptyOrWhitespace(fromAmount) ||
      !isNumber(fromAmount) ||
      isEmptyOrWhitespace(toAmount) ||
      !isNumber(toAmount) ||
      isEmptyOrWhitespace(discountType) ||
      isEmptyOrWhitespace(orderType)
    ) {
      toast.error(
        " Please fill all fields correctly. Discount and Amounts must be numeric."
      );
      return;
    }

    setLoading(true);
    try {
      const requestBody = {
        userid: userID.trim(),
        discount: discount.trim(),
        fromAmount: fromAmount.trim(),
        toAmount: toAmount.trim(),
        discountType: discountType.trim(),
        orderType: orderType.trim(),
        maxDiscount: maxDiscount.trim(),
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateDiscount`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          ` ${response?.data?.responseMessage || "Discount updated successfully."
          }`
        );

        // Reset discountData
        setNewCouponData({
          couponCode: "",
          discount: "",
          discountType: "",
          minOrderAmount: "",
          maxDiscountAmount: "",
          couponTitle: "",
          couponDiscription: "",
        });
        // getChargesApi();
      } else {
        toast.error(
          ` ${response?.data?.responseMessage || "Failed to update discount."}`
        );
      }
    } catch (error) {
      toast.error("Error updating discount. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleLoyaltyPointsChange = (e) => {
    setUpdateLoyaltyPointsData({
      ...updateLoyaltyPointsData,
      [e.target.name]: e.target.value,
    });
  };
  const handleFreeItemChanges = (e) => {
    setFreeItemData({ ...freeItemData, [e.target.name]: e.target.value });
  };
  // Fetch existing offers
  const getSpecialOffersApi = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getCustomerSpecialOffers`,
        { userid: userID },
        config
      );
      if (response.data.responseCode === "00") {
        setSpecialOffers(response.data.response || []);
      } else {
        toast.error(response.data.responseMessage || "Failed to fetch offers.");
      }
    } catch {
      toast.error("Error fetching special offers.");
    }
  };
  useEffect(() => {
    getSpecialOffersApi()
  }, [userID]);
  

  // Insert new offer
  const handleInsertSpecialOffer = async () => {
    const { customerMobile, offerType } = newSpecialOffer;
    if (!customerMobile || !offerType) {
      toast.error("Please enter customer mobile and select offer type.");
      return;
    }
    try {
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/insertCustomerSpecialOffers`,
        { userid: userID, customerMobile, offerType },
        config
      );
      if (response.data.responseCode === "00") {
        toast.success("Offer added successfully.");
        setNewSpecialOffer({ customerMobile: "", offerType: "" });
        getSpecialOffersApi();
      } else {
        toast.error(response.data.responseMessage || "Failed to add offer.");
      }
    } catch {
      toast.error("Error adding special offer.");
    }
  };

  // Update offer
  const handleUpdateSpecialOffer = async (offer) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateCustomerSpecialOffers`,
        { userid: userID, customerMobile: offer.customer_mobile, offerType: offer.offer_type },
        config
      );
      if (response.data.responseCode === "00") {
        toast.success("Offer updated successfully.");
        getSpecialOffersApi();
      } else {
        toast.error("Failed to update offer.");
      }
    } catch {
      toast.error("Error updating offer.");
    }
  };

  // Delete offer
  const handleDeleteSpecialOffer = async (offerid) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/deleteCustomerSpecialOffers`,
        { offerid },
        config
      );
      if (response.data.responseCode === "00") {
        toast.success("Offer deleted successfully.");
        getSpecialOffersApi();
      } else {
        toast.error("Failed to delete offer.");
      }
    } catch {
      toast.error("Error deleting offer.");
    }
  };


  const handleUpdateOrderTiming = async () => {
    const { opening, closing, weekOff } = updateOrderTimingData;

    if (!opening || !closing || !weekOff) {
      toast.error("All fields are required.");
      return;
    }

    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
        opening,
        closing,
        weekOff,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateRestaurantTiming`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          response?.data?.responseMessage ||
          "Order timing updated successfully."
        );
        setUpdateOrderTimingData({ opening: "", closing: "", weekOff: "" });
        // Optionally refetch updated timing info here
      } else {
        toast.error(
          response?.data?.responseMessage || "Failed to update order timing."
        );
      }
    } catch (error) {
      toast.error("Error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleUpdateLoyaltyPoints = async () => {
    const { points, value } = updateLoyaltyPointsData;

    if (!isNumber(points) || !isNumber(value)) {
      toast.error("Please enter valid numeric values for both fields.");
      return;
    }

    setLoading(true);

    try {
      const requestBody = {
        userid: userID,
        points: Number(points),
        value: Number(value),
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateMerchantLoyaltyPointsConfig`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          response?.data?.responseMessage ||
          "Loyalty points updated successfully."
        );

        // Optional: Reset form if needed
        setUpdateLoyaltyPointsData({ points: "", value: "" });

        getLoyaltyPointsApi();
      } else {
        toast.error(
          response?.data?.responseMessage || "Failed to update loyalty points."
        );
      }
    } catch (error) {
      toast.error("Error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  const handleUpdatePrintSetting = async () => {
    const { normalFontSize, largeFontSize, pageWidth, anlookActive, autoPrint } = printSettingData;

    if (![normalFontSize, largeFontSize, pageWidth].every(isNumber)) {
      toast.error("Please enter valid numeric values for all fields.");
      return;
    }

    setLoading(true);

    try {
      const requestBody = {
        userid: userID,
        printConfig: [
          { key: "normalFontSize", value: normalFontSize },
          { key: "largeFontSize", value: largeFontSize },
          { key: "pageWidth", value: pageWidth },
          { key: "anlookActive", value: anlookActive ? "1" : "0" },
          { key: "autoPrint", value: autoPrint ? "1" : "0" }
        ]
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updatePrintSettings`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(response?.data?.responseMessage || "Print settings updated successfully.");
        setPrintSettingData({
          normalFontSize: "",
          largeFontSize: "",
          pageWidth: "",
          anlookActive: false,
          autoPrint: false
        });
        reciptDetailsApi();
      } else {
        toast.error(response?.data?.responseMessage || "Failed to update print settings.");
      }
    } catch (error) {
      toast.error("Error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const [serviceloading, setServiceLoading] = useState(false);

  // Fetch services from API
  const getServicesApi = async () => {
    setServiceLoading(true);
    try {
      const requestBody = { userid: userID };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getOrderTypeOptions`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        setServiceData(response.data.response);
      } else {
        toast.error("Failed to load services.");
      }
    } catch (error) {
      toast.error("Error fetching services.");
    } finally {
      setServiceLoading(false);
    }
  };

  // Toggle service ON/OFF
  const handleUpdateServicesAPI = async (orderType, currentStatus) => {
    setServiceLoading(true);
    try {
      const requestBody = {
        userid: userID,
        orderType: orderType,
        status: currentStatus === "Y" ? "N" : "Y",
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateOrderTypeOptions`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success("Service status updated successfully.");
        getServicesApi(); // Refresh list
      } else {
        toast.error("Failed to update service status.");
      }
    } catch (error) {
      toast.error("Error occurred. Please try again.");
    } finally {
      setServiceLoading(false);
    }
  };

  const reciptDetailsApi = async () => {
    try {
      const response = await axios.post(`${baseUrl}/api/Order/getReceiptData`, {
        userid: userID,
      });

      if (response.data.responseCode === "00") {
        const data = response.data.response[0];

        // Parse printSettings here, ensuring it's always an array
        let parsedSettings = [];
        if (data.printSettings) {
          try {
            parsedSettings = typeof data.printSettings === "string"
              ? JSON.parse(data.printSettings)
              : data.printSettings;
          } catch (error) {
            console.error("Failed to parse printSettings:", error);
          }
        }

        setPrintSettingDetails({
          autoPrint: data.autoPrint,
          printOn: data.printOn,
          printOption: data.printOption,
          printSettings: parsedSettings,
        });
      } else {
        console.error("Failed to fetch print settings, responseCode:", response.data.responseCode);
      }
    } catch (error) {
      console.error("Error fetching print settings:", error);
    }
  };

  useEffect(() => {
    reciptDetailsApi();
    // fetchOrganizationDetails();
  }, []);
  useEffect(() => {
    if (printSettingDetails?.printSettings && typeof printSettingDetails.printSettings === "string") {
      try {
        const parsedSettings = JSON.parse(printSettingDetails.printSettings);
        setPrintSettingDetails(prev => ({
          ...prev,
          printSettings: parsedSettings,
        }));
      } catch (err) {
        console.error("Failed to parse printSettings:", err);
      }
    }
  }, [printSettingDetails]);
  const [attemptedSubmit, setAttemptedSubmit] = useState(false);

  const handleSetFreeItems = async () => {
    setAttemptedSubmit(true);
    const { minAmount, singleUse } = freeItemData;

    if (!isNumber(minAmount)) {
      toast.error("Please enter a valid amount and select a free item.");
      return;
    }
    if (!singleUse) {
      toast.error("Please select customer type.");
      return;
    }
    if (!selectedFreeItem) {
      toast.error("Please select a free item.");
      return;
    }

    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
        minAmount,
        singleUse,
        item: selectedFreeItem,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/addFreeItems`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          response.data.responseMessage || "Free item set successfully."
        );
        getLoyaltyPointsApi();
      } else {
        toast.error(
          response.data.responseMessage || "Failed to set free item."
        );
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleCreateNewCoupon = async () => {
    const {
      couponCode,
      discount,
      discountType,
      minOrderAmount,
      maxDiscountAmount,
      couponTitle,
      couponDiscription,
    } = newCouponData;

    if (
      isEmptyOrWhitespace(couponCode) ||
      !isNumber(discount) ||
      isEmptyOrWhitespace(discountType) ||
      !isNumber(minOrderAmount) ||
      !isNumber(maxDiscountAmount) ||
      isEmptyOrWhitespace(couponTitle) ||
      isEmptyOrWhitespace(couponDiscription)
    ) {
      toast.error(
        "Please fill all fields correctly. Discount and amounts must be numeric."
      );
      return;
    }

    setLoading(true);

    try {
      const requestBody = {
        userid: userID,
        couponCode: couponCode.trim(),
        discount: Number(discount),
        discountType: discountType.trim(),
        minOrderAmount: Number(minOrderAmount),
        maxDiscountAmount: Number(maxDiscountAmount),
        couponTitle: couponTitle.trim(),
        couponDiscription: couponDiscription.trim(),
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/createMerchantCouponCode`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          response?.data?.responseMessage || "Coupon created successfully"
        );

        // Reset form
        setNewCouponData({
          couponCode: "",
          discount: "",
          discountType: "",
          minOrderAmount: "",
          maxDiscountAmount: "",
          couponTitle: "",
          couponDiscription: "",
        });

        getCouponApi();
      } else {
        toast.error(
          response?.data?.responseMessage || "Failed to create coupon"
        );
      }
    } catch (error) {
      toast.error("Error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getLoyaltyPointsApi = async () => {
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getMerchantLoyaltyPointsConfig`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        setLoyaltyPointsData(response.data.data);
      } else {
      }
    } catch (error) {
      toast.error("Error updating delivery charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  const getTimingApi = async () => {
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getRestaurantTiming`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        setTimingData(response.data.data);
      } else {
      }
    } catch (error) {
      toast.error("Error updating delivery charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getCouponApi = async () => {
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getMerchantCouponCodes`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        setCouponData(response.data.data);
      } else {
      }
    } catch (error) {
      toast.error("Error updating delivery charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getChargesApi = async () => {
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getDeliveryChargesAndDiscount`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        const { charges, discount } = response.data.data;

        // Update delivery charges and discounts from API response
        setChargesData(charges);
        setDiscountsData(discount);

        // toast.success(
        //   `${
        //     response?.data?.responseMessage ||
        //     "Delivery charges updated successfully."
        //   }`
        // );
      } else {
        // toast.error(
        //   `${
        //     response?.data?.responseMessage ||
        //     "Failed to update delivery charges."
        //   }`
        // );
      }
    } catch (error) {
      toast.error("Error updating delivery charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getSettlementApi = async () => {
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getSettlementConfig`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        const { charges, discount } = response.data.data;

        // Update delivery charges and discounts from API response
        setChargesData(charges);
        setDiscountsData(discount);
      } else {
      }
    } catch (error) {
      // toast.error("Error updating delivery charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteDiscount = async (discountId) => {
    try {
      const requestBody = {
        userid: userID,
        discountId: discountId,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/deleteDiscount`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(response?.data?.responseMessage);

        getChargesApi();
      } else {
        toast.error(`${response?.data?.responseMessage || "Failed to remove"}`);
      }
    } catch (error) {
      // toast.error("Error updating delivery charges. Please try again.");
    }
  };
  const handleDeleteDeliveryCharges = async (chargeId) => {
    try {
      const requestBody = {
        userid: userID,
        chargeId: chargeId,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/deleteDeliveryCharges`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(response?.data?.responseMessage);

        getChargesApi();
      } else {
        toast.error(`${response?.data?.responseMessage || "Failed to remove"}`);
      }
    } catch (error) {
      // toast.error("Error updating delivery charges. Please try again.");
    }
  };
  const handleDeleteCoupon = async (couponId) => {
    try {
      const requestBody = {
        userid: userID,
        couponId: couponId,
        operation: "DELETE",
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/disableMerchantCouponCode`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(response?.data?.responseMessage);

        getCouponApi();
      } else {
        toast.error(`${response?.data?.responseMessage || "Failed to remove"}`);
      }
    } catch (error) {
      // toast.error("Error updating delivery charges. Please try again.");
    }
  };

  const [orderCharges, setOrderCharges] = useState([]);
  const getOrderChargesApi = async () => {
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getOrderCharges`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        setOrderCharges(response.data.response);
      } else {
      }
    } catch (error) {
      // toast.error("Error updating delivery charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  // new Order Chagrge Payload
  const [newOrderCharge, setNewOrderCharge] = useState({
    userid: "",
    discount: "",
    fromAmount: "",
    toAmount: "",
    chargeType: "",
    chargeOn: "",
  });
  const handleOrderChargeChange = (e) => {
    const { name, value } = e.target;
    setNewOrderCharge((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleUpdateOrderCharges = async () => {
    const { userid, charges, fromAmount, toAmount, chargeType } =
      newOrderCharge;
    if (isEmptyOrWhitespace(chargeType)) {
      toast.error(
        "Please fill all fields correctly. Charges and Amounts must be numeric."
      );
      return;
    }
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
        charges: "",
        fromAmount: "",
        toAmount: "",
        chargeType: "",
        chargeOn: chargeType, // or any appropriate static/dynamic value
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateOrderCharges`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        toast.success(
          response.data.responseMessage || "Order charges updated successfully."
        );
        // Reset form
        setNewOrderCharge({
          userid: userID,
          charges: "",
          fromAmount: "",
          toAmount: "",
          chargeType: "",
        });
        getOrderChargesApi();
      } else {
        toast.error(
          response.data.responseMessage || "Failed to update charges."
        );
      }
    } catch (error) {
      toast.error("Error updating charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getChargesApi();
    getOrderChargesApi();
    getSettlementApi();
    getCouponApi();
    getLoyaltyPointsApi();
    getTimingApi();
    getServicesApi();
  }, [userID]);
  const [catalogueStore, setCatalogueStore] = useState([]);
  const allcatalogueAPI = async () => {
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
        secret: "string",
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getMerchantMenuItems`,
        requestBody,
        config
      );
      console.log(response.data.response);
      if (response.data.responseCode === "00") {
        setCatalogueStore(response.data.response);
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    allcatalogueAPI();
  }, [userID]);
  const toggleCategory = (catId) => {
    setExpandedCategories((prev) =>
      prev.includes(catId)
        ? prev.filter((id) => id !== catId)
        : [...prev, catId]
    );
  };
  const filteredCategories = useMemo(() => {
    if (!catalogueStore) return [];
    return catalogueStore
      .map((category) => {
        const filteredItems = (category.menu_items || []).filter((item) =>
          item?.item_name?.toLowerCase().includes(searchText.toLowerCase())
        );
        return {
          ...category,
          menu_items: filteredItems, // make sure to keep it as `menu_items` so your component works
        };
      })
      .filter((category) => category.menu_items.length > 0); // remove empty categories
  }, [catalogueStore, searchText]);
  useEffect(() => {
    if (searchText.trim()) {
      const matchedIds = filteredCategories.map((cat) => String(cat.cat_id));
      setExpandedCategories(matchedIds);
    } else {
      // Optional: collapse all
      const firstCatId = String(catalogueStore?.[0]?.cat_id || "");
      setExpandedCategories(firstCatId ? [firstCatId] : []);
    }
  }, [filteredCategories, searchText, catalogueStore]);


  // order CHrges COnfiguration code here###############################################################################################################
  // New state for order charges config
  const [orderChargesConfig, setOrderChargesConfig] = useState([]);
  const [newOrderChargesConfig, setNewOrderChargesConfig] = useState({
    fromAmount: "",
    toAmount: "",
    charges: "",
    chargesType: "",
    chargesOn: "",
    orderType: "",
  });


  // Fetch existing order charges
  const getOrderChargesConfigApi = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getOrderChargesConfig`,
        { userid: userID },
        config
      );
      if (response.data.responseCode === "00") {
        setOrderChargesConfig(response.data.response || []);
      } else {
        toast.error(response.data.responseMessage || "Failed to fetch charges.");
      }
    } catch (error) {
      toast.error("Error fetching order charges config.");
    } finally {
      setLoading(false);
    }
  };


  // Insert / Update order charges
  const handleSaveOrderChargesConfig = async () => {
    const { fromAmount, toAmount, charges, chargesType, chargesOn, orderType } =
      newOrderChargesConfig;

    if (!fromAmount || !toAmount || !charges || !chargesType || !chargesOn || !orderType) {
      toast.error("Please fill all fields.");
      return;
    }

    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
        fromAmount,
        toAmount,
        charges,
        chargesType,
        chargesOn,
        orderType,
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/insertOrderChargesConfig`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage || "Saved successfully.");
        setNewOrderChargesConfig({
          fromAmount: "",
          toAmount: "",
          charges: "",
          chargesType: "",
          chargesOn: "",
          orderType: "",
        });
        getOrderChargesConfigApi(); // refresh list
      } else {
        toast.error(response.data.responseMessage || "Failed to save.");
      }
    } catch (error) {
      toast.error("Error saving order charges config.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userID) {
      getOrderChargesConfigApi();
    }
  }, [userID]);




  //  Code for the banner section add on on the last tab #####################################################################################################################
  // Banner
  const [bannerData, setBannerData] = useState({
    bannerid: "",   // leave empty on create
    userid: userID, // will auto-update from client selection
    title: "",
    description: "",
    isNew: "N",     // default "N"
    backgroundColor: "#ffffff",
    textColor: "#000000",
  });

  const [bannerList, setBannerList] = useState([]);

  // Input handler
  const handleBannerChange = (e) => {
    const { name, value } = e.target;
    setBannerData((prev) => ({ ...prev, [name]: value }));
  };

  // Create Banner
  const handleCreateBanner = async () => {
    try {
      const requestBody = {
        ...bannerData,
        userid: userID,
        bannerid: "", // ensure empty
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/addCatalogBanners`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success("Banner created successfully!");
        setBannerData({
          bannerid: "",
          userid: userID,
          title: "",
          description: "",
          isNew: "N",
          backgroundColor: "#ffffff",
          textColor: "#000000",
        });
        getBannerList(); // refresh
      } else {
        toast.error(response.data.responseMessage || "Failed to create banner.");
      }
    } catch (error) {
      toast.error("Error creating banner.");
    }
  };

  // Fetch banners
  const getBannerList = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getCatalogBannersAdmin`,
        { userid: userID },
        config
      );
      if (response.data.responseCode === "00") {
        setBannerList(response.data.response);
      }
    } catch {
      toast.error("Error fetching banners.");
    }
  };

  // Delete banner
  const handleDeleteBanner = async (bannerid) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/deleteCatalogBanners`,
        { bannerid },
        config
      );
      if (response.data.responseCode === "00") {
        toast.success("Banner deleted.");
        getBannerList();
      } else {
        toast.error("Failed to delete banner.");
      }
    } catch {
      toast.error("Error deleting banner.");
    }
  };

  // Auto fetch banners when client changes
  useEffect(() => {
    if (userID) getBannerList();
  }, [userID]);

  //  Code for the Configuration add on on the last tab #####################################################################################################################
  const [deliveryType, setDeliveryType] = useState("");
  const [selectedDeliveryType, setSelectedDeliveryType] = useState("");
  const [power, setPower] = useState("");
  const [haveSubscriptionPlan, setHaveSubscriptionPlan] = useState(false);
  const [selectedPartnerType, setSelectedPartnerType] = useState("restaurant");
  const [userData, setUserData] = useState({});
  const [subscriptionData, setSubscriptionData] = useState(null);
  // const [userID, setUserID] = useState(null);
  const [imageLink, setImageLink] = useState("");
  const [organizationName, setOrganizationName] = useState("N/A");
  const [includeGST, setIncludeGST] = useState(false);
  const [gst, setGst] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [businessAddress, setBusinessAddress] = useState("");
  const [paymentGateway, setPaymentGateway] = useState("RAZORPAY");
  const [receiptDetails, setReceiptDetails] = useState(null);
  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [address, setAddress] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [tagLine1, setTagLine1] = useState("");
  const [tagLine2, setTagLine2] = useState("");
  const [watermark1, setWatermark1] = useState("");
  const [watermark2, setWatermark2] = useState("");
  const [gstnum, setGstNum] = useState("");

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [reason, setReason] = useState("");

  const [step, setStep] = useState(1); // Step state for tracking the current screen

  // Function to handle closing the modal
  const handleCloseModal = () => {
    setStep(1); // Reset to step 1
    setShowCancelModal(false);
  };
  const handleNext = () => setStep(step + 1);
  const handleBack = () => setStep(step - 1);

  const subscriptionDetailsApi = async (userid) => {
    try {

      const responseBody = {
        userid: userid,
      };
      const response = await axios.post(
        `${baseUrl}/api/Entitlement/fetchSubscriptionDetails`,
        responseBody,
        config
      );
      if (response.data.responseCode === "00") {
        setSubscriptionData(response.data.data);
        setHaveSubscriptionPlan(true);
      } else {
        console.error(
          "Failed to fetch subscription details:",
          response.data.responseMessage
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleCancelSubscription = async () => {
    try {


      const response = await axios.post(
        `${baseUrl}/api/Entitlement/cancelSubscriptionPlan`,
        {
          userid: userID,
          reason: reason,
        },
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setReason("");
      } else {
        toast.error(response.data.responseMessage);
        setReason("");
      }
      setShowCancelModal(false); // Close the modal after successful API call
    } catch (error) {
      console.error("Error canceling subscription:", error);
      alert("An error occurred while canceling the subscription.");
    }
  };

  const handleLogoUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      // Get the Base64 string from the reader result
      const base64String = reader.result;

      console.log("Base64 Encoded Image: ", base64String);

      // If you need to display the image, you can use this Base64 string
      // For example, set it to the state and use it in the img src
      setImageLink(base64String); // Assuming setImageLink is your state setter for the image URL
    };

    if (file) {
      reader.readAsDataURL(file); // This will read the file and convert it to Base64
    }
  };

  const [organizationDetails, setOrganizationDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const fetchOrganizationDetails = async (userid) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/User/getOrganizationDetails`,
        {
          userid: userid,
        }
      );

      if (response.data.responseCode === "00") {
        const details = response.data.response;
        setOrganizationDetails(details);
        // Pre-fill modal fields with fetched data
        setOrganizationName(details.organization_name);
        setIncludeGST(!!details.gst);
        setGst(details.gst);
        setGstNumber(details.gst);
        setBusinessAddress(details.business_address || "");
        setPaymentGateway(details.payment_gateway);
        setImageLink(details.brand_image);
      } else {
        console.error("Failed to fetch organization details");
      }
    } catch (error) {
      console.error("Error fetching organization details:", error);
    }
  };
  const handleUpdateClick = () => {
    setShowModal(true);
  };

  const handleSaveChanges = async () => {
    setShowModal(false);
    await updateOrganizationInfo(); // Call your update function here
  };

  const updateOrganizationInfo = async () => {
    if (!imageLink) {
      console.error("Image URL is not set yet!");
      return;
    }

    try {
      const formData = {
        userid: userID,
        organizationName: organizationName,
        gst: gstNumber,
        pan_no: "",
        brand_image: imageLink,
        payment_gateway: paymentGateway,
      };

      const response = await axios.post(
        `${baseUrl}/api/User/editOrganizationInfo`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.responseCode === "00") {
        toast.success(
          response.data.response.message ||
          "Organization info updated successfully!"
        );
      } else {
        toast.error("Failed to update organization info");
      }

      console.log("Organization info updated successfully", response.data);
    } catch (error) {
      toast.error("There was an error updating the organization info!");
      console.error(
        "There was an error updating the organization info!",
        error
      );
    }
  };

  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");
    if (userID) {
      const parsedUser = JSON.parse(storedUser);

      if (userID) {
        verifyCredentials(userID);
        fetchOrganizationDetails(userID);
        subscriptionDetailsApi(userID);
        fetchReceiptDetails(userID);
        GetBankInfo(userID);
        getDeliveryTypeAPI(userID);
      }
    }
  }, [userID]);
  const copyText = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      console.log("Copied to clipboard: ", text);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  useEffect(() => {
    const storedPower = sessionStorage.getItem("power");
    const user = sessionStorage.getItem("user");

    if (storedPower) {
      setPower(storedPower);
    }


  }, []);

  const verifyCredentials = async (userId) => {
    try {
      const response = await fetch(
        `${baseUrl}/api/Whatsapp/getWhatsappCredentials`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: userId,
          }),
        }
      );

      const responseData = await response.json();

      if (responseData.responseCode === "00") {
        setUserData(responseData.response);
      } else if (responseData.responseCode === "01") {
        setUserData({});
      } else {
        console.error("Unexpected response code:", responseData);
      }
    } catch (error) {
      console.error("Error during verification:", error);
    }
  };
  const handleUpdateReceiptClick = () => {
    setShowReceiptModal(true);
  };
  const handleSaveReceiptChanges = async () => {
    setShowReceiptModal(false);
    await updateReceiptInfo();
  };
  const updateReceiptInfo = async () => {
    try {
      const formData = {
        userid: userID,
        address: address,
        phone_no: phoneNo,
        tagLine1: tagLine1,
        tagLine2: tagLine2,
        watermark1: watermark1,
        watermark2: watermark2,
        gst: gst,
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/editReceiptData`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.responseCode === "00") {
        toast.success("Receipt info updated successfully!");
      } else {
        toast.error("Failed to update receipt info");
      }
    } catch (error) {
      toast.error("Error updating receipt info!");
      console.error("Error updating receipt info:", error);
    }
  };
  const [Account, setAccount] = useState("");
  const [Ifsc, setIfsc] = useState("");
  const [BankName, setBankName] = useState("");
  const [AccountHolderName, setAccountHolderName] = useState("");
  const [BankInfo, setBankInfo] = useState([]);
  const updateBankInfo = async () => {
    try {
      const BankData = {
        userid: userID,
        account: Account,
        ifsc: Ifsc,
        bankName: BankName,
        bankHolderName: AccountHolderName,
      };

      const response = await axios.post(
        `${baseUrl}/api/Transactions/addSettlementAccount`,
        BankData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setStateNull();
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error updating bank info!");
      console.error("Error updating bank info:", error);
    }
  };
  function setStateNull() {
    setBankName("");
    setAccountHolderName("");
    setAccount("");
    setIfsc("");
  }
  const GetBankInfo = async (userID) => {
    try {
      const BankData = {
        userid: userID,
      };
      const response = await axios.post(
        `${baseUrl}/api/Transactions/getSettlementAccountList`,
        BankData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.responseCode === "00") {
        setBankInfo(response.data.response);
        console.log(BankInfo);
      } else {
        // toast.error(response.data.responseMessage);
      }
    } catch (error) {
      // toast.error("Error getting bank info!");
      console.error("Error bank info:", error);
    }
  };
  // bank Modal state controler
  const [showBankModal, setShowBankModal] = useState(false);
  // Function to handle saving changes
  const handleSaveBankChanges = () => {
    setShowBankModal(false);
    updateBankInfo();
  };
  const fetchReceiptDetails = async (userID) => {
    try {

      const requestBody = {
        userid: userID,
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/getReceiptData`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        const details = response.data.response[0]; // Fetch the first item from the response array
        setReceiptDetails(details);
        // Pre-fill modal fields with fetched data
        setAddress(details.address);
        setPhoneNo(details.phone_no);
        setTagLine1(details.tag_line1); // Correct key from the response
        setTagLine2(details.tag_line2); // Correct key from the response
        setWatermark1(details.watermark1);
        setWatermark2(details.watermark2);
        setGstNum(details.gst); // Correct key from the response
      } else {
        console.error("Failed to fetch receipt details");
      }
    } catch (error) {
      console.error("Error fetching receipt details:", error);
    }
  };
  // Fetch current delivery type
  const getDeliveryTypeAPI = async (userID) => {
    try {

      const requestBody = {
        userid: userID,
        secret: "string",
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/getDeliveryProvider`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        setDeliveryType(response.data.response.deliveryPartner);
      } else {
        console.log("No Data Found");
      }
    } catch {
      console.log("Error fetching delivery type.");
    }
  };
  // Update selected delivery partner
  const selectDeliveryPartnerAPI = async (partnerType) => {
    try {

      const requestBody = {
        userid: userID,
        deliveryPartner: partnerType,
        secret: "string",
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/updateDeliveryProvider`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        setDeliveryType(partnerType);
        Swal.fire("Success", "Delivery partner updated successfully.", "success");
      } else {
        Swal.fire("Error", "Failed to update delivery partner.", "error");
      }
    } catch {
      Swal.fire("Error", "An error occurred while updating delivery partner.", "error");
    }
  };
  // Handle user selection with confirmation
  const handleDeliveryTypeChange = (partnerType) => {

    if (partnerType === deliveryType) {
      Swal.fire({
        title: "Delivery Type Already Selected",
        text: "This delivery type is already active. To switch, please select a different option.",
        icon: "info",
        showCancelButton: false,
      });

    } else {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to change the delivery partner?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, change it!",
        cancelButtonText: "No, cancel!",
      }).then((result) => {
        if (result.isConfirmed) {
          setSelectedDeliveryType(partnerType);
          selectDeliveryPartnerAPI(partnerType);
        }
      });
    }
  };


  return (
    <div className='bg-danger marginRight'>
      <>  <NoIndex />
        <div className="d-flex justify-content-center text-center">
          <ToastContainer />
        </div>
        <div>
          <div
            className="p-4 bg-white"
            style={{
              height: "100vh",
              fontFamily: "Nunito,sans-serif",
            }}
          >
            <div className=" justify-content-center">
              <div className="row g-3 px-4 admin-catalogue-wrapper">
                {/* Left Card */}
                <div className="col-md-4 admin-popup">
                  <div className="admin-left-card-4 text-white p-4 text-start rounded-2 h-100">
                    <h5 className="fw-bold mb-2 admin-text-animate">Order Setting</h5>
                    <hr className="admin-divider" />
                    <p className="mb-0 small admin-text-animate">
                      Configure order-level preferences including discounts, delivery charges, loyalty points, and other restaurant-specific settings.
                    </p>
                  </div>
                </div>
                {/* Right Card */}
                <div className="col-md-8 admin-popup">
                  <div className="admin-right-card-4 p-4 rounded-2 h-100">
                    <h5 className="admin-restaurant-subtitle mb-3">Select Client to Configure</h5>
                    <select
                      className="form-select form-select-sm admin-custom-dropdown"
                      aria-label="Select Client"
                      onChange={(e) => {
                        const selectedData = JSON.parse(e.target.value);
                        HandleClientChange(selectedData);
                      }}
                    >
                      <option value="">Select Client...</option>
                      {Clients.map((item, index) => (
                        <option
                          key={index}
                          value={JSON.stringify({ code: item.us_code, name: item.us_name })}
                        >
                          {item.us_code} : {item.us_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <hr />
              {userID && <> {currentCatalogueStatus && (
                <div className="d-flex align-items-center border p-2 bg-light rounded-3 mb-4">
                  <div className="me-3">
                    <span className="text-3-2 fw-semibold">Order Accepting</span>
                  </div>
                  <div className="order-switch d-flex align-items-center cursor-pointer">
                    <label className="order-switch-label mb-0">
                      <input
                        type="checkbox"
                        checked={currentCatalogueStatus === "show"}
                        onChange={handleToggle}
                      />
                      <span
                        className={`order-slider order-round ms-2 ${currentCatalogueStatus === "hide" ? "off" : "on"
                          }`}
                      >
                        {currentCatalogueStatus === "hide" ? "OFF" : "ON"}
                      </span>
                    </label>
                  </div>
                </div>
              )}

                <div>
                  <div>
                    <div
                      className=" bg-white"
                      style={{
                        height: "100vh",
                        fontFamily: "Nunito,sans-serif",
                      }}
                    >
                      <div className=" justify-content-center">
                        <Form className="d-flex justify-content-between pb-4">
                          <Form.Label className="CreateCampaign">Order Settings</Form.Label>
                        </Form>
                        {/* Tab Headers */}
                        <ul className="nav nav-tabs mb-4 bg-light p-2 rounded shadow-sm">
                          {[
                            { key: "deliveryCharges", label: "Delivery Charges" },
                            { key: "services", label: "Services" },

                            { key: "discounts", label: "Discounts" },
                            { key: "coupon", label: "Coupon" },
                            { key: "loyaltyPoints", label: "Loyalty Points" },
                            { key: "free", label: "Free Items" },
                            { key: "orderCharges", label: "Order Charges" },
                            { key: "orderTiming", label: "Order Timing" },
                            { key: "printing", label: "Receipt Printing" },
                            { key: "bannercreate", label: "Banner" },
                            { key: "config", label: "Configuration" },

                          ].map((tab) => (
                            <li className="nav-item" key={tab.key}>
                              <button
                                className={`nav-link fw-semibold rounded-top px-3 py-2 mx-1 ${activeTab === tab.key
                                  ? "active order-section-button bg-green-order  text-white"
                                  : "text-dark bg-light"
                                  }`}
                                onClick={() => setActiveTab(tab.key)}
                              >
                                {tab.label}
                              </button>
                            </li>
                          ))}
                        </ul>
                        {/* Tab Contents */}
                        {loading ? (
                          <div className="m-5 p-5 d-flex justify-content-center">
                            <div className="loader"></div>
                          </div>
                        ) : (
                          <>
                            {/* Order Charges Tab */}
                            {activeTab === "orderCharges" && (
                              <div className="row col-12 m-0 p-0">
                                {/* Existing Charges List */}
                                <div className="col-8 h-100 mb-3">
                                  {["dining", "home_delivery", "takeaway", "car_order"].map((type) => {
                                    const filtered = orderChargesConfig.filter(
                                      (charge) => charge.order_type === type
                                    );
                                    if (filtered.length === 0) return null;

                                    // color classes by type
                                    let cardColor = "bg-light";
                                    if (type === "dining") cardColor = "bg-primary bg-opacity-10";
                                    if (type === "home_delivery") cardColor = "bg-success bg-opacity-10";
                                    if (type === "takeaway") cardColor = "bg-warning bg-opacity-10";
                                    if (type === "car_order") cardColor = "bg-info bg-opacity-10";

                                    return (
                                      <div key={type} className="mb-4">
                                        <h5 className="fw-bold text-capitalize mb-3">
                                          {type.replace("_", " ")} Charges
                                        </h5>
                                        {filtered.map((charge) => (
                                          <div
                                            key={charge.pk_charge_id}
                                            className={`p-3 mb-3 border rounded-4 ${cardColor}`}
                                          >
                                            <div className="d-flex justify-content-between">
                                              <span className="text-muted">From:</span>
                                              <span className="fw-medium">₹{parseFloat(charge.from_amount).toFixed(2)}</span>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                              <span className="text-muted">To:</span>
                                              <span className="fw-medium">₹{parseFloat(charge.to_amount).toFixed(2)}</span>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                              <span className="text-muted">Charges:</span>
                                              <span className="fw-medium">
                                                {parseFloat(charge.charges).toFixed(2)}
                                                {charge.charge_type === "percentage" ? "%" : " ₹"}
                                              </span>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                              <span className="text-muted">Charges On:</span>
                                              <span className="fw-medium">{charge.charges_on}</span>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                              <span className="text-muted">Payment Method:</span>
                                              <span className="fw-medium">{charge.payment_method}</span>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                              <span className="text-muted">Status:</span>
                                              <span className={`fw-bold ${charge.status === "Y" ? "text-success" : "text-danger"}`}>
                                                {charge.status === "Y" ? "Active" : "Inactive"}
                                              </span>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    );
                                  })}
                                </div>

                                {/* Insert/Update Form */}
                                <div className="col-4 mb-3">
                                  <div className="p-4 bg-light border-0 rounded-4">
                                    <h5 className="fw-semibold text-success mb-4">Add/Update Order Charges</h5>
                                    <div className="row g-3">
                                      <div className="col-12">
                                        <label className="form-label">From Amount</label>
                                        <input type="number" className="form-control"
                                          value={newOrderChargesConfig.fromAmount}
                                          onChange={(e) => setNewOrderChargesConfig({ ...newOrderChargesConfig, fromAmount: e.target.value })}
                                        />
                                      </div>
                                      <div className="col-12">
                                        <label className="form-label">To Amount</label>
                                        <input type="number" className="form-control"
                                          value={newOrderChargesConfig.toAmount}
                                          onChange={(e) => setNewOrderChargesConfig({ ...newOrderChargesConfig, toAmount: e.target.value })}
                                        />
                                      </div>
                                      <div className="col-12">
                                        <label className="form-label">Charges</label>
                                        <input type="number" className="form-control"
                                          value={newOrderChargesConfig.charges}
                                          onChange={(e) => setNewOrderChargesConfig({ ...newOrderChargesConfig, charges: e.target.value })}
                                        />
                                      </div>
                                      <div className="col-12">
                                        <label className="form-label">Charges Type</label>
                                        <select className="form-select"
                                          value={newOrderChargesConfig.chargesType}
                                          onChange={(e) => setNewOrderChargesConfig({ ...newOrderChargesConfig, chargesType: e.target.value })}
                                        >
                                          <option value="">Select</option>
                                          <option value="fixed">Fixed</option>
                                          <option value="percentage">Percentage</option>
                                        </select>
                                      </div>
                                      <div className="col-12">
                                        <label className="form-label">Charges On</label>
                                        <select className="form-select"
                                          value={newOrderChargesConfig.chargesOn}
                                          onChange={(e) => setNewOrderChargesConfig({ ...newOrderChargesConfig, chargesOn: e.target.value })}
                                        >
                                          <option value="">Select</option>
                                          <option value="message">Per Message</option>
                                          <option value="order">Per Order</option>
                                        </select>
                                      </div>
                                      <div className="col-12">
                                        <label className="form-label">Order Type</label>
                                        <select className="form-select"
                                          value={newOrderChargesConfig.orderType}
                                          onChange={(e) => setNewOrderChargesConfig({ ...newOrderChargesConfig, orderType: e.target.value })}
                                        >
                                          <option value="">Select</option>
                                          <option value="home_delivery">Home Delivery</option>
                                          <option value="takeaway">Takeaway</option>
                                          <option value="dining">Dining</option>
                                          <option value="car_order">Car Order</option>
                                        </select>
                                      </div>
                                      <div className="col-12">
                                        <button className="btn btn-success w-100"
                                          onClick={handleSaveOrderChargesConfig}
                                          disabled={loading}
                                        >
                                          {loading ? "Saving..." : "Save Charges"}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* services Tab */}
                            {activeTab === "services" && (
                              <div className="row">
                                <div className="col-12">
                                  <div className="p-4 bg-light border-0 rounded-4">
                                    <h5 className="fw-semibold text-success mb-4">
                                      Activate/Deactivate Services
                                    </h5>

                                    <div className="row g-4">
                                      {serviceData.length === 0 && (
                                        <div className="text-danger">No services found.</div>
                                      )}
                                      {serviceData.map((service) => (
                                        <div
                                          key={service.id}
                                          className="d-flex justify-content-between align-items-center bg-white p-3 rounded shadow-sm"
                                        >
                                          <span className="text-dark text-capitalize">
                                            {service.orderType.replace("_", " ")}
                                          </span>
                                          <button
                                            className={`btn ${service.status === "Y" ? "btn-danger" : "btn-success"
                                              }`}
                                            onClick={() =>
                                              handleUpdateServicesAPI(service.orderType, service.status)
                                            }
                                            disabled={loading}
                                          >
                                            {service.status === "Y" ? "Deactivate" : "Activate"}
                                          </button>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Delivery Charges Tab */}
                            {activeTab === "deliveryCharges" && (
                              <div className="row">
                                <div className="col-12">
                                  {/* Current Delivery Charge Display */}
                                  {chargesData.map((charge, index) => (
                                    <div key={index} className="col">
                                      <div className="p-4 bg-white w-100  border rounded-4 mb-3">
                                        <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                                          <h5 className="fw-semibold text-success ">
                                            Currently Applied Delivery Charges
                                          </h5>
                                          <div>
                                            <button
                                              className="btn btn-danger"
                                              onClick={() => {
                                                handleDeleteDeliveryCharges(charge.id);
                                              }}
                                            >
                                              Remove
                                            </button>
                                          </div>
                                        </div>
                                        <div className="d-flex flex-column gap-2">
                                          <div className="d-flex justify-content-between">
                                            <span className="text-muted">Charges:</span>
                                            <span className="fw-medium text-dark">
                                              {charge.charge_type === "fixed" ? "₹" : ""}
                                              {parseFloat(charge.charges).toFixed(2)}
                                              {charge.charge_type === "fixed" ? "" : "%"}
                                            </span>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <span className="text-muted">Type:</span>
                                            <span className="fw-medium text-dark">
                                              {charge.charge_type}
                                            </span>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <span className="text-muted">From:</span>
                                            <span className="fw-medium text-dark">
                                              ₹{parseFloat(charge.from_amt).toFixed(2)}
                                            </span>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <span className="text-muted">To:</span>
                                            <span className="fw-medium text-dark">
                                              ₹{parseFloat(charge.to_amt).toFixed(2)}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}

                                  <div className="p-4 bg-light border-0  rounded-4 mb-5">
                                    <h5 className="fw-semibold text-success mb-4">
                                      {" "}
                                      Update Delivery Charges
                                    </h5>
                                    <div className="row g-4">
                                      <div className="col-md-6">
                                        <label className="form-label">Charges</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="charges"
                                          value={deliveryData.charges}
                                          onChange={handleDeliveryChange}
                                          placeholder="Enter Charges"
                                        />
                                      </div>
                                      <div className="col-md-6">
                                        <label className="form-label">From Amount</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="fromAmount"
                                          value={deliveryData.fromAmount}
                                          onChange={handleDeliveryChange}
                                          placeholder="Enter From Amount"
                                        />
                                      </div>
                                      <div className="col-md-6">
                                        <label className="form-label">To Amount</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="toAmount"
                                          value={deliveryData.toAmount}
                                          onChange={handleDeliveryChange}
                                          placeholder="Enter To Amount"
                                        />
                                      </div>
                                      <div className="col-md-6">
                                        <label className="form-label">Charge Type</label>
                                        <select
                                          className="form-control"
                                          name="chargeType"
                                          value={deliveryData.chargeType}
                                          onChange={handleDeliveryChange}
                                        >
                                          <option value="">Select Charge Type</option>
                                          <option value="fixed">Fixed</option>
                                          <option value="percentage">Percentage</option>
                                        </select>
                                      </div>
                                    </div>
                                    <div>
                                      <button
                                        className="btn btn-success mt-4"
                                        onClick={handleUpdateDeliveryCharges}
                                        disabled={loading}
                                      >
                                        {loading
                                          ? "Updating..."
                                          : "Update Delivery Charges"}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Discounts Tab */}
                            {activeTab === "discounts" && (
                              <div className="row">
                                <div className="col-12">
                                  {/* Current Discount Display */}
                                  {discountsData.length > 0 ? (
                                    <>
                                      {discountsData.map((discount, index) => (
                                        <div key={index} className="col">
                                          <div className="p-4 bg-white w-100  border rounded-4 mb-3">
                                            <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                                              <h5 className="fw-semibold text-success ">
                                                Currently Applied Discount
                                              </h5>
                                              <div>
                                                <button
                                                  className="btn btn-danger"
                                                  onClick={() => {
                                                    handleDeleteDiscount(discount.id);
                                                  }}
                                                >
                                                  Remove
                                                </button>
                                              </div>
                                            </div>
                                            <div className="d-flex flex-column gap-2">
                                              <div className="d-flex justify-content-between">
                                                <span className="text-muted">
                                                  Discount:
                                                </span>
                                                <span className="fw-medium text-dark">
                                                  {discount.charge_type === "fixed"
                                                    ? "₹"
                                                    : ""}
                                                  {parseFloat(discount.discount).toFixed(2)}
                                                  {discount.charge_type === "fixed"
                                                    ? ""
                                                    : "%"}
                                                </span>
                                              </div>
                                              <div className="d-flex justify-content-between">
                                                <span className="text-muted">Type:</span>
                                                <span className="fw-medium text-dark">
                                                  {discount.discount_type}
                                                </span>
                                              </div>
                                              <div className="d-flex justify-content-between">
                                                <span className="text-muted">From:</span>
                                                <span className="fw-medium text-dark">
                                                  ₹
                                                  {parseFloat(discount.from_amt).toFixed(2)}
                                                </span>
                                              </div>
                                              <div className="d-flex justify-content-between">
                                                <span className="text-muted">To:</span>
                                                <span className="fw-medium text-dark">
                                                  ₹{parseFloat(discount.to_amt).toFixed(2)}
                                                </span>
                                              </div>
                                              <div className="d-flex justify-content-between">
                                                <span className="text-muted">
                                                  {" "}
                                                  Maximum Discount Limit
                                                </span>
                                                <span className="fw-medium text-dark">
                                                  ₹
                                                  {parseFloat(
                                                    discount.max_discount
                                                  ).toFixed(2)}
                                                </span>
                                              </div>

                                              <div className="d-flex justify-content-between">
                                                <span className="text-muted">
                                                  Order Type:
                                                </span>
                                                <span className="fw-medium text-dark">
                                                  {discount.order_type}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </>
                                  ) : (
                                    <></>
                                  )}

                                  <div className="p-4 bg-light border-0  rounded-4">
                                    <h5 className="fw-semibold text-success mb-4">
                                      Update Discount
                                    </h5>
                                    <div className="row g-4">
                                      <div className="col-md-6">
                                        <label className="form-label">Discount</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="discount"
                                          value={discountData.discount}
                                          onChange={handleDiscountChange}
                                          placeholder="Enter Discount"
                                        />
                                      </div>
                                      <div className="col-md-6">
                                        <label className="form-label">From Amount</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="fromAmount"
                                          value={discountData.fromAmount}
                                          onChange={handleDiscountChange}
                                          placeholder="Enter From Amount"
                                        />
                                      </div>
                                      <div className="col-md-6">
                                        <label className="form-label">To Amount</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="toAmount"
                                          value={discountData.toAmount}
                                          onChange={handleDiscountChange}
                                          placeholder="Enter To Amount"
                                        />
                                      </div>
                                      <div className="col-md-6">
                                        <label className="form-label">
                                          Maximum Discount Limit{" "}
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="maxDiscount"
                                          value={discountData.maxDiscount}
                                          onChange={handleDiscountChange}
                                          placeholder="Enter Maximum Discount Limit "
                                        />
                                      </div>

                                      <div className="col-md-6">
                                        <label className="form-label">Discount Type</label>
                                        <select
                                          className="form-control"
                                          name="discountType"
                                          value={discountData.discountType}
                                          onChange={handleDiscountChange}
                                        >
                                          <option value="">Select Discount Type</option>
                                          <option value="fixed">Fixed</option>
                                          <option value="percentage">Percentage</option>
                                        </select>
                                      </div>
                                      <div className="col-md-6">
                                        <label className="form-label">Order Type</label>
                                        <select
                                          className="form-select"
                                          name="orderType"
                                          value={discountData.orderType}
                                          onChange={handleDiscountChange}
                                        >
                                          <option value="">Select Order Type</option>
                                          <option value="homeDelivery">
                                            Home Delivery
                                          </option>
                                          <option value="takeaway">Takeaway</option>
                                          <option value="dining">Dining</option>
                                        </select>
                                      </div>
                                    </div>
                                    <div>
                                      <button
                                        className="btn btn-success mt-4 "
                                        onClick={handleUpdateDiscount}
                                        disabled={loading}
                                      >
                                        {loading ? "Updating..." : "Update Discount"}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div className="p-4 bg-light border-0 rounded-4 mt-4">
                                  <h5 className="fw-semibold text-primary mb-4">Special Customer Offers</h5>

                                  {/* Existing Offers */}
                                  {specialOffers.length > 0 ? (
                                    <Table bordered hover responsive>
                                      <thead>
                                        <tr>
                                          <th>Customer Mobile</th>
                                          <th>Offer Type</th>
                                          <th>Actions</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {specialOffers.map((offer) => (
                                          <tr key={offer.pk_offer_id}>
                                            <td>{offer.customer_mobile}</td>
                                            <td>{offer.offer_type}</td>
                                            <td>
                                              <button
                                                className="btn btn-sm btn-warning me-2"
                                                onClick={() => handleUpdateSpecialOffer(offer)}
                                              >
                                                Update
                                              </button>
                                              <button
                                                className="btn btn-sm btn-danger"
                                                onClick={() => handleDeleteSpecialOffer(offer.pk_offer_id)}
                                              >
                                                Delete
                                              </button>
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </Table>
                                  ) : (
                                    <p className="text-muted">No special offers found.</p>
                                  )}

                                  {/* Add New Offer */}
                                  <div className="row g-3 mt-3">
                                    <div className="col-md-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Customer Mobile"
                                        value={newSpecialOffer.customerMobile}
                                        onChange={(e) =>
                                          setNewSpecialOffer({ ...newSpecialOffer, customerMobile: e.target.value })
                                        }
                                      />
                                    </div>
                                    <div className="col-md-6">
                                      <select
                                        className="form-select"
                                        value={newSpecialOffer.offerType}
                                        onChange={(e) =>
                                          setNewSpecialOffer({ ...newSpecialOffer, offerType: e.target.value })
                                        }
                                      >
                                        <option value="">Select Offer Type</option>
                                        <option value="home_delivery_free">Free Home Delivery</option>
                                        <option value="extra_discount">Extra Discount</option>
                                        <option value="free_item">Free Item</option>
                                      </select>
                                    </div>
                                    <div className="col-12">
                                      <button
                                        className="btn btn-success w-100"
                                        onClick={handleInsertSpecialOffer}
                                      >
                                        Add Special Offer
                                      </button>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            )}

                            {/* Coupon Tab */}
                            {activeTab === "coupon" && (
                              <div className="">
                                <div className="row col-12 p-0 m-0">
                                  {/* Current Coupon Display */}
                                  {couponData.length > 0 ? (
                                    <>
                                      {couponData.map((coupon, index) => (
                                        <div key={index} className="col-6 p-0 m-0">
                                          <div className="p-4 m-2 bg-white  border rounded-4 mb-3">
                                            <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                                              <h5 className="fw-semibold text-success">
                                                Coupon Code :{" "}
                                                <span className="text-italic text-dark">
                                                  {coupon.coupon_code}
                                                </span>
                                              </h5>
                                              <div className="d-flex justify-content-center gap-3">
                                                <button
                                                  className="btn btn-warning "
                                                  disabled
                                                //  onClick={() => handleDeleteCoupon(coupon.id)}
                                                >
                                                  Disable
                                                </button>
                                                <button
                                                  className="btn btn-danger"
                                                  onClick={() =>
                                                    handleDeleteCoupon(coupon.id)
                                                  }
                                                >
                                                  Delete
                                                </button>
                                              </div>
                                            </div>

                                            <div className="d-flex flex-column gap-2">
                                              <div className="d-flex justify-content-between">
                                                <span className="text-muted">
                                                  Coupon Code:
                                                </span>
                                                <span className="fw-medium text-dark">
                                                  {coupon.coupon_code}
                                                </span>
                                              </div>

                                              <div className="d-flex justify-content-between">
                                                <span className="text-muted">
                                                  Discount:
                                                </span>
                                                <span className="fw-medium text-dark">
                                                  {coupon.discount_type === "fixed"
                                                    ? "₹"
                                                    : ""}
                                                  {parseFloat(coupon.discount).toFixed(2)}
                                                  {coupon.discount_type === "fixed"
                                                    ? ""
                                                    : "%"}
                                                </span>
                                              </div>

                                              <div className="d-flex justify-content-between">
                                                <span className="text-muted">
                                                  Discount Type:
                                                </span>
                                                <span className="fw-medium text-dark">
                                                  {coupon.discount_type}
                                                </span>
                                              </div>

                                              <div className="d-flex justify-content-between">
                                                <span className="text-muted">
                                                  Minimum Order Amount:
                                                </span>
                                                <span className="fw-medium text-dark">
                                                  ₹
                                                  {parseFloat(coupon.min_amount).toFixed(2)}
                                                </span>
                                              </div>

                                              <div className="d-flex justify-content-between">
                                                <span className="text-muted">Title:</span>
                                                <span className="fw-medium text-dark">
                                                  {coupon.coupon_title}
                                                </span>
                                              </div>

                                              <div className="d-flex justify-content-between">
                                                <span className="text-muted">
                                                  Description:
                                                </span>
                                                <span className="fw-medium text-dark">
                                                  {coupon.coupon_description}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </>
                                  ) : (
                                    <div className="text-center text-danger mb-4">
                                      No coupon found.
                                    </div>
                                  )}

                                  <div className="p-4 bg-light border-0  rounded-4">
                                    {/* {JSON.stringify(newCouponData)} */}
                                    <h5 className="fw-semibold text-success mb-4">
                                      Create New Coupon
                                    </h5>
                                    <div className="row g-4">
                                      <div className="col-md-6">
                                        <label className="form-label">Coupon Code</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="couponCode"
                                          value={newCouponData.couponCode}
                                          onChange={handleNewCouponChange}
                                          placeholder="Enter Coupon Code"
                                        />
                                      </div>
                                      <div className="col-md-6">
                                        <label className="form-label">Discount</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="discount"
                                          value={newCouponData.discount}
                                          onChange={handleNewCouponChange}
                                          placeholder="Enter Discount"
                                        />
                                      </div>
                                      <div className="col-md-6">
                                        <label className="form-label">
                                          Min Order Amount
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="minOrderAmount"
                                          value={newCouponData.minOrderAmount}
                                          onChange={handleNewCouponChange}
                                          placeholder="Enter Min Order Amount"
                                        />
                                      </div>
                                      <div className="col-md-6">
                                        <label className="form-label">
                                          Maximum Discount Amount
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="maxDiscountAmount"
                                          value={newCouponData.maxDiscountAmount}
                                          onChange={handleNewCouponChange}
                                          placeholder="Enter Maximum Discount Amount"
                                        />
                                      </div>
                                      <div className="col-md-6">
                                        <label className="form-label">Coupon Title</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="couponTitle"
                                          value={newCouponData.couponTitle}
                                          onChange={handleNewCouponChange}
                                          placeholder="Enter Coupon Title"
                                        />
                                      </div>
                                      <div className="col-md-6">
                                        <label className="form-label">
                                          Coupon Discription{" "}
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="couponDiscription"
                                          value={newCouponData.couponDiscription}
                                          onChange={handleNewCouponChange}
                                          placeholder="Enter Coupon Discription "
                                        />
                                      </div>

                                      <div className="col-md-6">
                                        <label className="form-label">Discount Type</label>
                                        <select
                                          className="form-control"
                                          name="discountType"
                                          value={newCouponData.discountType}
                                          onChange={handleNewCouponChange}
                                        >
                                          <option value="">Select Discount Type</option>
                                          <option value="fixed">Fixed</option>
                                          <option value="percentage">Percentage</option>
                                        </select>
                                      </div>
                                      {/* <div className="col-md-6">
                             <label className="form-label">Order Type</label>
                             <select
                               className="form-select"
                               name="orderType"
                               value={discountData.orderType}
                               onChange={handleNewCouponChange}
                             >
                               <option value="">Select Order Type</option>
                               <option value="homeDelivery">
                                 Home Delivery
                               </option>
                               <option value="takeaway">Takeaway</option>
                               <option value="dining">Dining</option>
                             </select>
                           </div> */}
                                    </div>
                                    <div>
                                      <button
                                        className="btn btn-success mt-4 "
                                        onClick={handleCreateNewCoupon}
                                        disabled={loading}
                                      >
                                        {loading ? "Creating..." : "Create Coupon"}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {activeTab === "loyaltyPoints" && (
                              <div className="row">
                                <div className="col-12">
                                  {loyaltyPointsData.length > 0 ? (
                                    loyaltyPointsData.map((item, index) => (
                                      <div key={index} className="col">
                                        <div className="p-4 bg-white w-100 border rounded-4 mb-3">
                                          <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                                            <h5 className="fw-semibold text-success mb-0">
                                              Loyalty Points
                                            </h5>
                                            <button className="btn btn-danger">
                                              Remove
                                            </button>
                                          </div>

                                          <div className="d-flex flex-column gap-2">
                                            <div className="d-flex justify-content-between">
                                              <span className="text-muted">Points:</span>
                                              <span className="fw-medium text-dark">
                                                {item.points}
                                              </span>
                                            </div>

                                            <div className="d-flex justify-content-between">
                                              <span className="text-muted">Value (₹):</span>
                                              <span className="fw-medium text-dark">
                                                ₹{parseFloat(item.value).toFixed(2)}
                                              </span>
                                            </div>

                                            <div className="d-flex justify-content-between">
                                              <span className="text-muted">
                                                Created On:
                                              </span>
                                              <span className="fw-medium text-dark">
                                                {item.created_on}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))
                                  ) : (
                                    <div className="text-center text-danger mb-4">
                                      No loyalty points found.
                                    </div>
                                  )}

                                  <div className="p-4 bg-light border-0 rounded-4">
                                    <h5 className="fw-semibold text-success mb-4">
                                      Update Loyalty Points
                                    </h5>
                                    <div className="row g-4">
                                      <div className="col-md-6">
                                        <label className="form-label">Loyalty Points</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="points"
                                          value={updateLoyaltyPointsData.points}
                                          onChange={handleLoyaltyPointsChange}
                                          placeholder="Enter Loyalty Points"
                                        />
                                      </div>
                                      <div className="col-md-6">
                                        <label className="form-label">
                                          Loyalty Points Value in Rupees
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="value"
                                          value={updateLoyaltyPointsData.value}
                                          onChange={handleLoyaltyPointsChange}
                                          placeholder="Enter Value in ₹"
                                        />
                                      </div>
                                    </div>
                                    <div>
                                      <button
                                        className="btn btn-success mt-4"
                                        onClick={handleUpdateLoyaltyPoints}
                                        disabled={loading}
                                      >
                                        {loading ? "Updating..." : "Update Loyalty Points"}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {/* Free Item Tab */}
                            {activeTab === "free" && (
                              <div className="row">
                                <div className="col-12">
                                  <div className="p-4 bg-light border-0 rounded-4">
                                    <h5 className="fw-semibold text-success mb-4">
                                      Select Free Item
                                    </h5>
                                    <div className="row">
                                      {/* Form Section */}
                                      <div className="col-md-5">
                                        <div className="bg-white p-4 rounded shadow-sm">
                                          <div className="mb-3">
                                            <label className="form-label">
                                              Minimum Order Amount
                                            </label>
                                            <input
                                              type="text"
                                              className={`form-control ${!isNumber(freeItemData.minAmount) &&
                                                attemptedSubmit
                                                ? "is-invalid"
                                                : ""
                                                }`}
                                              name="minAmount"
                                              value={freeItemData.minAmount}
                                              onChange={handleFreeItemChanges}
                                              placeholder="Enter Minimum Order Amount"
                                            />
                                          </div>

                                          <div className="mb-3">
                                            <label className="form-label">
                                              Customer Type
                                            </label>
                                            <select
                                              className="form-control"
                                              name="singleUse"
                                              value={freeItemData.singleUse}
                                              onChange={handleFreeItemChanges}
                                            >
                                              <option value="Y">
                                                First Time User Only
                                              </option>
                                              <option value="N">For All</option>
                                            </select>
                                          </div>

                                          <div className="mb-3">
                                            <label className="form-label">
                                              Selected Free Item
                                            </label>
                                            {selectedFreeItem?.item_name ? (
                                              <div className="d-flex align-items-center bg-light py-2 rounded">
                                                <div
                                                  className="flex-shrink-0"
                                                  style={{
                                                    width: "5rem",
                                                    height: "5rem",
                                                    overflow: "hidden",
                                                    borderRadius: "10px",
                                                  }}
                                                >
                                                  <img
                                                    src={selectedFreeItem.photo}
                                                    alt={selectedFreeItem.item_name}
                                                    className="w-100 h-100 object-fit-cover"
                                                  />
                                                </div>
                                                <div className="ms-3">
                                                  <p className="fw-semibold mb-0">
                                                    {selectedFreeItem.item_name}
                                                  </p>
                                                </div>
                                              </div>
                                            ) : (
                                              <p className="text-muted small">
                                                No item selected
                                              </p>
                                            )}
                                          </div>

                                          <button
                                            className="btn btn-success w-100 mt-3"
                                            onClick={handleSetFreeItems}
                                            disabled={loading}
                                          >
                                            {loading ? "Submitting..." : "Submit"}
                                          </button>
                                        </div>
                                      </div>

                                      {/* Item Selection Section */}
                                      <div className="col-md-7">
                                        <div className="bg-white p-4 rounded shadow-sm">
                                          <h5 className="mb-4">
                                            Choose a free item from menu
                                          </h5>
                                          {loading ? (
                                            <div className="d-flex justify-content-center my-5">
                                              <div
                                                className="spinner-border text-success"
                                                role="status"
                                              />
                                            </div>
                                          ) : (
                                            <>
                                              {filteredCategories.map((category) => {
                                                const catId = String(category.cat_id);
                                                const isExpanded =
                                                  expandedCategories.includes(catId);
                                                const itemsToShow = isExpanded
                                                  ? category.menu_items
                                                  : [];

                                                return (
                                                  <div key={catId}>
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                      <p
                                                        className="fw-bold text-dark"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() =>
                                                          toggleCategory(catId)
                                                        }
                                                      >

                                                        {category.category_name}
                                                      </p>
                                                      {category.menu_items.length > 1 && (
                                                        <button
                                                          className="btn btn-sm bg-light text-primary"
                                                          onClick={() =>
                                                            toggleCategory(catId)
                                                          }
                                                        >
                                                          <img
                                                            src={
                                                              isExpanded
                                                                ? downArrow
                                                                : rightArrow
                                                            }
                                                            style={{
                                                              width: "1rem",
                                                              height: "1rem",
                                                            }}
                                                            alt="Toggle"
                                                          />
                                                        </button>
                                                      )}
                                                    </div>

                                                    <div>
                                                      {itemsToShow.map((item) => (
                                                        <div
                                                          key={item.item_id}
                                                          className={`d-flex align-items-center p-2 rounded mb-2 cursor-pointer ${selectedFreeItem?.item_id ===
                                                            item.item_id
                                                            ? "bg-light "
                                                            : "bg-light"
                                                            }`}
                                                        // onClick={() =>
                                                        //   setSelectedFreeItem(item)
                                                        // }
                                                        >
                                                          <input
                                                            type="radio"
                                                            name="selectedFreeItem"
                                                            className="form-check-input me-3"
                                                            checked={
                                                              selectedFreeItem?.item_id ===
                                                              item.item_id
                                                            }
                                                            onChange={() =>
                                                              setSelectedFreeItem(item)
                                                            } // Optional: covered by parent div
                                                            onClick={(e) =>
                                                              e.stopPropagation()
                                                            } // Prevent parent click when clicking radio
                                                          />
                                                          <div
                                                            className="flex-shrink-0"
                                                            style={{
                                                              width: "5rem",
                                                              height: "5rem",
                                                              borderRadius: "10px",
                                                              overflow: "hidden",
                                                            }}
                                                          >
                                                            <img
                                                              src={item.photo}
                                                              alt={item.item_name}
                                                              className="w-100 h-100 object-fit-cover"
                                                            />
                                                          </div>
                                                          <div className="ms-3">
                                                            <p className="mb-0 fw-medium">
                                                              {item.item_name}
                                                            </p>
                                                            <p className="text-muted small mb-0">
                                                              {item.prices.formatted_price}
                                                            </p>
                                                          </div>
                                                        </div>
                                                      ))}
                                                    </div>
                                                    <hr />
                                                  </div>
                                                );
                                              })}
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {activeTab === "orderTiming" && (
                              <div className="row">
                                <div className="col-12">
                                  {timingData &&
                                    timingData.openingTime &&
                                    timingData.closingTime ? (
                                    <div className="col">
                                      <div className="p-4 bg-white w-100 border rounded-4 mb-3">
                                        <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                                          <h5 className="fw-semibold text-success mb-0">
                                            Current Restaurant Time
                                          </h5>
                                        </div>

                                        <div className="d-flex flex-column gap-2">
                                          <div className="d-flex justify-content-between">
                                            <span className="text-muted">
                                              Opening Time:
                                            </span>
                                            <span className="fw-medium text-dark">
                                              {new Date(
                                                `1970-01-01T${timingData.openingTime}Z`
                                              ).toLocaleTimeString([], {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                              })}
                                            </span>
                                          </div>

                                          <div className="d-flex justify-content-between">
                                            <span className="text-muted">
                                              Closing Time:
                                            </span>
                                            <span className="fw-medium text-dark">
                                              {new Date(
                                                `1970-01-01T${timingData.closingTime}Z`
                                              ).toLocaleTimeString([], {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                              })}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="text-center text-danger mb-4">
                                      No restaurant timing found.
                                    </div>
                                  )}

                                  <div className="p-4 bg-light border-0 rounded-4">
                                    <h5 className="fw-semibold text-success mb-4">
                                      Update Restaurant Timing
                                    </h5>
                                    <div className="row g-4">
                                      <div className="col-md-2">
                                        <label className="form-label">Opening Time</label>
                                        <input
                                          type="time"
                                          className="form-control"
                                          name="opening"
                                          value={updateOrderTimingData.opening}
                                          onChange={handleOrderTimingChange}
                                        />
                                      </div>
                                      <div className="col-md-2">
                                        <label className="form-label">Closing Time</label>
                                        <input
                                          type="time"
                                          className="form-control"
                                          name="closing"
                                          value={updateOrderTimingData.closing}
                                          onChange={handleOrderTimingChange}
                                        />
                                      </div>
                                      <div className="col-md-4">
                                        <label className="form-label">Week Off</label>
                                        <select
                                          className="form-select"
                                          name="weekOff"
                                          value={updateOrderTimingData.weekOff}
                                          onChange={handleOrderTimingChange}
                                        >
                                          <option value="">Select a day</option>
                                          <option value="Sunday">Sunday</option>
                                          <option value="Monday">Monday</option>
                                          <option value="Tuesday">Tuesday</option>
                                          <option value="Wednesday">Wednesday</option>
                                          <option value="Thursday">Thursday</option>
                                          <option value="Friday">Friday</option>
                                          <option value="Saturday">Saturday</option>
                                          <option value="No_Week_Off">No Week Off</option>

                                        </select>
                                      </div>
                                    </div>
                                    <div>
                                      <button
                                        className="btn btn-success mt-4"
                                        onClick={handleUpdateOrderTiming}
                                        disabled={loading}
                                      >
                                        {loading ? "Updating..." : "Update Timing"}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Receipt Printing Tab */}
                            {activeTab === "printing" && (
                              <div className="row">
                                <div className="col-6">
                                  {printSettingDetails ? (
                                    <div className="col">
                                      <div className="p-4 bg-white w-100 border rounded-4 mb-3">
                                        <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                                          <h5 className="fw-semibold text-success mb-0">Print Settings</h5>
                                        </div>

                                        <div className="d-flex flex-column gap-2">
                                          <div className="d-flex flex-column gap-2">
                                            <div className="d-flex justify-content-between">
                                              <span className="text-muted">Use Anlook Printing Software:</span>
                                              <span className="fw-medium text-dark">
                                                {printSettingDetails?.printSettings?.find(p => p.key === "anlookActive")?.value === "1"
                                                  ? "Enabled"
                                                  : "Disabled"}
                                              </span>
                                            </div>

                                            <div className="d-flex justify-content-between">
                                              <span className="text-muted">Auto-Print Receipts:</span>
                                              <span className="fw-medium text-dark">
                                                {printSettingDetails?.printSettings?.find(p => p.key === "autoPrint")?.value === "1"
                                                  ? "Enabled"
                                                  : "Disabled"}
                                              </span>
                                            </div>

                                            <div className="d-flex justify-content-between">
                                              <span className="text-muted">Receipt Print Mode:</span>
                                              <span className="fw-medium text-dark">
                                                {printSettingDetails?.printSettings?.find(p => p.key === "autoPrint")?.value === "1"
                                                  ? "Print automatically after payment"
                                                  : "Manual print with one click"}
                                              </span>
                                            </div>
                                          </div>

                                          <hr />

                                          {printSettingDetails?.printSettings?.slice(0, 3).map((setting, idx) => (
                                            <div key={idx} className="d-flex justify-content-between">
                                              <span className="text-muted">{setting.key}:</span>
                                              <span className="fw-medium text-dark">{setting.value}</span>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="text-center text-danger mb-4">
                                      No print setting data found.
                                    </div>
                                  )}

                                  <div className="p-4 bg-light border-0 rounded-4">
                                    <h5 className="fw-semibold text-success mb-4">Update Printing Setting</h5>
                                    <div className="row g-4">
                                      <div className="col-md-12">
                                        <label className="form-label">Normal Font Size (PX)</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="normalFontSize"
                                          value={printSettingData.normalFontSize}
                                          onChange={handlePrintSettingChange}
                                          placeholder="Enter Normal Font Size"
                                        />
                                      </div>
                                      <div className="col-md-12">
                                        <label className="form-label">Large Font Size (PX)</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="largeFontSize"
                                          value={printSettingData.largeFontSize}
                                          onChange={handlePrintSettingChange}
                                          placeholder="Enter Large Font Size"
                                        />
                                      </div>
                                      <div className="col-md-12">
                                        <label className="form-label">Page Width (MM)</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="pageWidth"
                                          value={printSettingData.pageWidth}
                                          onChange={handlePrintSettingChange}
                                          placeholder="Enter Page Width"
                                        />
                                      </div>
                                      <div className="col-md-12">
                                        <div className="form-check form-switch mt-2">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="anlookActive"
                                            name="anlookActive"
                                            checked={printSettingData.anlookActive}
                                            onChange={handlePrintSettingChange}
                                          />
                                          <label className="form-check-label" htmlFor="anlookActive">
                                            Activate Anlook Printing Software
                                          </label>
                                        </div>
                                      </div>

                                      <div className="col-md-12">
                                        <div className="form-check form-switch mt-2">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="autoPrint"
                                            name="autoPrint"
                                            checked={printSettingData.autoPrint}
                                            onChange={handlePrintSettingChange}
                                          />
                                          <label className="form-check-label" htmlFor="autoPrint">
                                            Enable Auto Printing (disable for One-Click)
                                          </label>
                                        </div>
                                      </div>
                                    </div>

                                    <div>
                                      <button
                                        className="btn btn-success mt-4"
                                        onClick={handleUpdatePrintSetting}
                                        disabled={loading}
                                      >
                                        {loading ? "Updating..." : "Save"}
                                      </button>
                                    </div>
                                  </div>
                                </div>

                                {/* Right Column */}
                                <div className="col-6 d-flex flex-column align-items-center justify-content-center">
                                  <div className="bg-light rounded border p-4 text-center d-flex align-items-center gap-4 w-100">
                                    <h4 className="fw-bold">Anlook Auto Printing Software</h4>
                                    <div className="position-relative d-inline-block shadow single-line-css">
                                      <a
                                        href="https://drive.google.com/drive/folders/1e6_CaxQnLNx0D96IqAlKFEc0erspm_IK?usp=sharing"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-success px-4 py-2 fs-5"
                                      >
                                        Download Now
                                      </a>
                                      <span
                                        className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning text-dark"
                                        style={{ fontSize: '0.75rem' }}
                                        title="New Feature"
                                      >
                                        NEW
                                      </span>
                                    </div>
                                  </div>

                                  <div className="card bg-light mt-4 shadow-sm border-0 w-100">
                                    <div className="card-body px-4 px-md-5 py-4">
                                      <h4 className="fw-bold mb-4 text-primary text-center">Step-by-Step Installation Guide</h4>
                                      <ol className="fs-5 text-muted">
                                        <li className="mb-4">
                                          <strong>Download the Software:</strong><br />
                                          Click the green <span className="text-success fw-semibold">“Download Now”</span> button above to get the ZIP file from Google Drive.
                                        </li>
                                        <li className="mb-4">
                                          <strong>Extract the ZIP File:</strong><br />
                                          Right-click the ZIP file and choose <em>"Extract All..."</em> or use any unzipping tool.
                                        </li>
                                        <li className="mb-4">
                                          <strong>Run the Software:</strong><br />
                                          Open the folder and double-click <code>AnlookAutoPrint.exe</code>. It runs silently in the background.
                                        </li>
                                        <li className="mb-4">
                                          <strong>Set to Auto-Start (Optional):</strong><br />
                                          Contact our support team if you'd like help setting this up.
                                        </li>
                                        <li className="mb-2">
                                          <strong>Done!</strong><br />
                                          Your receipts will now print automatically!
                                        </li>
                                      </ol>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {/* Banner Creation For Admin */}
                            {activeTab === "bannercreate" && (
                              <div className="row">
                                {/* Left Side: Banner Form */}
                                <div className="col-md-6">
                                  <div className="p-4 bg-light border rounded-4">
                                    <h5 className="fw-semibold text-success mb-4">Create New Banner</h5>
                                    <div className="mb-3">
                                      <label className="form-label">Title</label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="title"
                                        value={bannerData.title}
                                        onChange={handleBannerChange}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <label className="form-label">Description</label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="description"
                                        value={bannerData.description}
                                        onChange={handleBannerChange}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <label className="form-label">New Badge?</label>
                                      <select
                                        className="form-select"
                                        name="isNew"
                                        value={bannerData.isNew}
                                        onChange={handleBannerChange}
                                      >
                                        <option value="N">No</option>
                                        <option value="Y">Yes</option>
                                      </select>
                                    </div>
                                    <div className="mb-3 d-flex gap-3">
                                      <div>
                                        <label className="form-label">Background Color</label>
                                        <input
                                          type="color"
                                          className="form-control form-control-color"
                                          name="backgroundColor"
                                          value={bannerData.backgroundColor}
                                          onChange={handleBannerChange}
                                        />
                                      </div>
                                      <div>
                                        <label className="form-label">Text Color</label>
                                        <input
                                          type="color"
                                          className="form-control form-control-color"
                                          name="textColor"
                                          value={bannerData.textColor}
                                          onChange={handleBannerChange}
                                        />
                                      </div>
                                    </div>
                                    <button className="btn btn-success w-100" onClick={handleCreateBanner}>
                                      Create Banner
                                    </button>
                                  </div>
                                </div>

                                {/* Right Side: Preview & List */}
                                <div className="col-md-6">
                                  <div className="p-4 bg-white border rounded-4 mb-3">
                                    <h6 className="fw-semibold">Live Preview</h6>
                                    <div
                                      className="p-3 rounded mt-3"
                                      style={{
                                        backgroundColor: bannerData.backgroundColor,
                                        color: bannerData.textColor,
                                      }}
                                    >
                                      <strong>{bannerData.title || "Banner Title"}</strong>
                                      <p className="mb-0">{bannerData.description || "Banner description here"}</p>
                                      {bannerData.isNew === "Y" && (
                                        <span className="badge bg-warning text-dark ms-2">NEW</span>
                                      )}
                                    </div>
                                  </div>

                                  <div className="p-4 bg-light border rounded-4">
                                    <h6 className="fw-semibold">Existing Banners</h6>
                                    {bannerList.length === 0 && (
                                      <p className="text-muted">No banners found.</p>
                                    )}
                                    {bannerList.map((b) => (
                                      <div
                                        key={b.bannerid}
                                        className="d-flex justify-content-between align-items-center p-2 bg-white rounded mb-2"
                                      >
                                        <div
                                          style={{
                                            backgroundColor: b.backgroundColor,
                                            color: b.textColor,
                                          }}
                                          className="p-2 rounded w-100"
                                        >
                                          <strong>{b.title}</strong> - {b.decription}
                                          {b.isNew === "Y" && (
                                            <span className="badge bg-warning text-dark ms-2">NEW</span>
                                          )}
                                        </div>
                                        <button
                                          className="btn btn-danger btn-sm ms-2"
                                          onClick={() => handleDeleteBanner(b.id)}
                                        >
                                          Delete
                                        </button>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            )}
                            {/* Banner Creation For Admin */}
                            {activeTab === "config" && (
                              <div className="row">
                                <>
                                  <NoIndex />
                                  <ToastContainer />
                                  <Modal show={showModal} onHide={() => setShowModal(false)}>
                                    <Modal.Header closeButton>
                                      <Modal.Title>Update Business Information</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <p className="campaignBoxName">
                                        Business Name
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={organizationName}
                                          onChange={(e) => setOrganizationName(e.target.value)}
                                        />
                                      </p>

                                      <p className="campaign-box-name d-flex align-items-center">
                                        <span className="me-2">Include GST:</span>
                                        <ToggleButtonGroup
                                          type="radio"
                                          name="includeGST"
                                          value={includeGST}
                                          onChange={(val) => setIncludeGST(val)}
                                          className="toggle-group"
                                        >
                                          <ToggleButton
                                            id="gst-yes"
                                            value={true}
                                            variant="outline-success"
                                            size="sm"
                                          >
                                            YES
                                          </ToggleButton>
                                          <ToggleButton
                                            id="gst-no"
                                            value={false}
                                            variant="outline-danger"
                                            size="sm"
                                          >
                                            NO
                                          </ToggleButton>
                                        </ToggleButtonGroup>
                                      </p>

                                      {includeGST && (
                                        <p className="campaignBoxName">
                                          GST Rate
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={gst}
                                            onChange={(e) => setGst(e.target.value)}
                                          />
                                        </p>
                                      )}

                                      <p className="campaignBoxName">
                                        GST Number (Optional)
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={gstNumber}
                                          onChange={(e) => setGstNumber(e.target.value)}
                                        />
                                      </p>

                                      <p className="campaignBoxName">
                                        Payment Gateway
                                        <select
                                          className="form-control"
                                          value={paymentGateway}
                                          onChange={(e) => setPaymentGateway(e.target.value)}
                                        >
                                          <option value="RAZORPAY"> Razorpay</option>
                                          <option value="PAYPAL"> Paypal</option>
                                          <option value="BUMPPYPAY"> Bumppy Pay</option>
                                        </select>
                                      </p>

                                      <p className="campaignBoxName">
                                        Business Logo
                                        <input
                                          type="file"
                                          className="form-control"
                                          onChange={handleLogoUpload}
                                        />
                                      </p>
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button variant="secondary" onClick={() => setShowModal(false)}>
                                        Cancel
                                      </Button>
                                      <Button variant="primary" onClick={handleSaveChanges}>
                                        Save Changes
                                      </Button>
                                    </Modal.Footer>
                                  </Modal>
                                  {/* Modal for updating bank details */}
                                  <Modal show={showBankModal} onHide={() => setShowBankModal(false)}>
                                    <Modal.Header closeButton>
                                      <Modal.Title>Update Bank Information</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <p className="campaignBoxName">
                                        Account Number
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={Account}
                                          onChange={(e) => setAccount(e.target.value)}
                                        />
                                      </p>
                                      <p className="campaignBoxName">
                                        IFSC Code
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={Ifsc}
                                          onChange={(e) => setIfsc(e.target.value)}
                                        />
                                      </p>
                                      <p className="campaignBoxName">
                                        Bank Name
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={BankName}
                                          onChange={(e) => setBankName(e.target.value)}
                                        />
                                      </p>
                                      <p className="campaignBoxName">
                                        Account Holder Name
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={AccountHolderName}
                                          onChange={(e) => setAccountHolderName(e.target.value)}
                                        />
                                      </p>
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button variant="secondary" onClick={() => setShowBankModal(false)}>
                                        Cancel
                                      </Button>
                                      <Button variant="primary" onClick={handleSaveBankChanges}>
                                        Add Account
                                      </Button>
                                    </Modal.Footer>
                                  </Modal>
                                  <div
                                    className=""
                                    style={{
                                      backgroundColor: "#fff",
                                      fontFamily: "Nunito, sans-serif",
                                    }}
                                  >

                                    <div className="">
                                      {/* <div className="d-flex justify-content-between">
           
            <div className="container p-0 m-0">
              

              {BankInfo && BankInfo.length > 0 ? (
                <>
                  <div className="settings-card-profile">
                    <div className="d-flex flex-column">
                      <div className="d-flex justify-content-between mb-2">
                        {" "}
                        <span>
                          {" "}
                          <p
                            className="campaignheading p-0 m-0"
                            style={{ fontWeight: "bold" }}
                          >
                            Bank Information
                          </p>
                        </span>
                        <div
                          className="blue-outline-button bg-white h-50 "
                          onClick={() => setShowBankModal(true)}
                          style={{ cursor: "pointer" }}
                        >
                          Add Account
                        </div>
                      </div>
                      <hr />
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>Account Number</th>
                            <th>Bank Name</th>
                          </tr>
                        </thead>
                        <tbody>
                          {BankInfo.map((info, index) => (
                            <tr key={info.id}>
                              <td>{info.us_account}</td>
                              <td>{info.bank_name}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
               
                </>
              ) : (
                <div className="settings-card-noprofile d-flex justify-content-between">
                  <div className="text-start ">
                    <h2> Add Bank Details </h2>
                    <p>
                      Order payments will be settled in the provided account.
                    </p>
                    <Button
                      className="blue-outline-button text-white "
                      onClick={() => setShowBankModal(true)}
                    >
                      Add Bank Info
                    </Button>
                  </div>
                  <div className="profile-avatar-noprofile mb-1">
                    <img
                      src={abank}
                      alt="Brand Logo"
                      style={{ height: "80px" }}
                      height={100}
                    />
                  </div>
                </div>
              )}
              <Modal
                show={showBankModal}
                onHide={() => setShowBankModal(false)}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Update Bank Information</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p className="campaignBoxName">
                    Account Number
                    <input
                      type="text"
                      className="form-control"
                      value={Account}
                      onChange={(e) => setAccount(e.target.value)}
                    />
                  </p>
                  <p className="campaignBoxName">
                    IFSC Code
                    <input
                      type="text"
                      className="form-control"
                      value={Ifsc}
                      onChange={(e) => setIfsc(e.target.value)}
                    />
                  </p>
                  <p className="campaignBoxName">
                    Bank Name
                    <input
                      type="text"
                      className="form-control"
                      value={BankName}
                      onChange={(e) => setBankName(e.target.value)}
                    />
                  </p>
                  <p className="campaignBoxName">
                    Account Holder Name
                    <input
                      type="text"
                      className="form-control"
                      value={AccountHolderName}
                      onChange={(e) => setAccountHolderName(e.target.value)}
                    />
                  </p>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => setShowBankModal(false)}
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" onClick={handleSaveBankChanges}>
                    Add Account
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          </div> */}
                                      <div className="CreateCampaign m-3 mt-0">Settings</div>

                                      <div className="row col-12 p-0 m-0 d-flex justify-content-start settings-grid">
                                        <div className="col-8 p-0 m-0">
                                          <div className="m-3 p-4 border rounded d-flex flex-column">
                                            <>
                                              <p className="campaignheading p-0 m-0">Delivery Service Type</p>
                                              <p className="campaignSubheading">
                                                <p>Choose the delivery service that suits your needs:</p>
                                                <hr />
                                                <ul className="text-dark">
                                                  <li>
                                                    <strong>Restaurant Delivery Service</strong>
                                                    - Perfect for restaurants with their own delivery staff, ensuring seamless order fulfillment.
                                                  </li>
                                                  <li>
                                                    <strong>Packky Delivery Service</strong> - Utilize our
                                                    platform's dedicated delivery partners for reliable and
                                                    efficient order deliveries.
                                                  </li>
                                                  <li>
                                                    <strong>DoorDash Delivery Service</strong> - Available
                                                    exclusively in the USA, connect with a vast network of delivery
                                                    professionals.
                                                  </li>
                                                </ul>
                                              </p>
                                              <hr className="p-0 m-0" />
                                              <div className="d-flex justify-content-between mt-4 delivery-partner-options gap-4">
                                                {[
                                                  { value: "RESTAURANT", label: "Restaurant Delivery Service" },
                                                  { value: "PACKKY", label: "Packky Delivery Service" },
                                                  { value: "DOORDASH", label: "DoorDash Delivery Service" },
                                                ].map((partner) => (
                                                  <div className="d-flex justify-content-center" key={partner.value}>
                                                    <label
                                                      className={`partner-option ${deliveryType === partner.value ? "selected" : ""
                                                        }`}
                                                      onClick={() => handleDeliveryTypeChange(partner.value)}
                                                    >
                                                      <input
                                                        type="radio"
                                                        name="partnerType"
                                                        value={partner.value}
                                                        checked={selectedDeliveryType === partner.value}
                                                        readOnly
                                                        className="me-2 visually-hidden"
                                                      />
                                                      <span className="option-label">{partner.label}</span>
                                                    </label>
                                                  </div>
                                                ))}
                                              </div>
                                            </>
                                          </div>
                                        </div>
                                        <div className="col-4 p-0 m-0  h-100 ">
                                          {BankInfo && BankInfo.length > 0 ? (
                                            <>
                                              <div className="border m-3  h-100 rounded p-4">
                                                <div className="d-flex flex-column h-100 ">
                                                  <div className="d-flex justify-content-between mb-2">
                                                    {" "}
                                                    <span>
                                                      {" "}
                                                      <p
                                                        className="campaignheading p-0 m-0"
                                                      >
                                                        Bank Details
                                                      </p>
                                                    </span>
                                                    <div
                                                      className="blue-outline-button bg-white h-50 "
                                                      onClick={() => setShowBankModal(true)}
                                                      style={{ cursor: "pointer" }}
                                                    >
                                                      Add Account
                                                    </div>
                                                  </div>
                                                  <hr />
                                                  {/* Bank Info Table */}
                                                  <Table striped bordered hover>
                                                    <thead>
                                                      <tr>
                                                        <th>Account Number</th>
                                                        <th>Bank Name</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {BankInfo.map((info, index) => (
                                                        <tr key={info.id}>
                                                          <td>{info.us_account}</td>
                                                          <td>{info.bank_name}</td>
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                  </Table>
                                                </div>
                                              </div>

                                            </>
                                          ) : (
                                            <div className="settings-card-noprofile d-flex justify-content-between border m-3  h-100 rounded p-4">
                                              <div className="text-start ">
                                                <p
                                                  className="campaignheading p-0 m-0"
                                                >
                                                  Add Bank Details
                                                </p>
                                                <p>
                                                  Order payments will be settled in the provided account.
                                                </p>
                                                <Button
                                                  className="blue-outline-button text-white "
                                                  onClick={() => setShowBankModal(true)}
                                                >
                                                  Add Bank Info
                                                </Button>
                                              </div>
                                              <div className="profile-avatar-noprofile mb-1">
                                                <img
                                                  src={abank}
                                                  alt="Brand Logo"
                                                  style={{ height: "80px" }}
                                                  height={100}
                                                />
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                        <div className="col-8 p-0 m-0">
                                          <div className=" m-3  p-4 border rounded  d-flex flex-column">
                                            {receiptDetails ? (
                                              <>
                                                <p className="campaignheading p-0 m-0">
                                                  Receipt Information
                                                </p>
                                                <p className="campaignSubheading">
                                                  This information will appear on the customer's receipt.
                                                </p>

                                                <hr />
                                                <div className="row col-12 p-0 m-0">
                                                  <div className=" col-lg-6 col-12 p-2 m-0 campaignBoxName">
                                                    Address
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      value={receiptDetails.address || "N/A"}
                                                      readOnly
                                                    />
                                                  </div>
                                                  <div className="col-lg-6 col-12 p-2 m-0 campaignBoxName">
                                                    Phone Number
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      value={receiptDetails.phone_no || "N/A"}
                                                      readOnly
                                                    />
                                                  </div>
                                                  <div className="col-lg-6 col-12 p-2 m-0 campaignBoxName">
                                                    Tagline 1
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      value={receiptDetails.tag_line1 || "N/A"}
                                                      readOnly
                                                    />
                                                  </div>
                                                  <div className="col-lg-6 col-12 p-2 m-0 campaignBoxName">
                                                    Tagline 2
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      value={receiptDetails.tag_line2 || "N/A"}
                                                      readOnly
                                                    />
                                                  </div>
                                                  <div className="col-lg-6 col-12 p-2 m-0 campaignBoxName">
                                                    Watermark 1
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      value={receiptDetails.watermark1 || "N/A"}
                                                      readOnly
                                                    />
                                                  </div>
                                                  <div className="col-lg-6 col-12 p-2 m-0 campaignBoxName">
                                                    Watermark 2
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      value={receiptDetails.watermark2 || "N/A"}
                                                      readOnly
                                                    />
                                                  </div>
                                                  <div className="col-lg-6 col-12 p-2 m-0 campaignBoxName">
                                                    GST
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      value={receiptDetails.gst || "N/A"}
                                                      readOnly
                                                    />
                                                  </div>
                                                  <div className="col-lg-12 col-12 p-2 m-0 ">
                                                    <Button
                                                      className="blue-button text-white px-5"
                                                      onClick={handleUpdateReceiptClick}
                                                    >
                                                      Update
                                                    </Button>
                                                  </div>
                                                </div>
                                              </>
                                            ) : (
                                              <div className="text-center p-3">
                                                <p>
                                                  <span className="text-dark text-3-2">
                                                    {" "}
                                                    Add Receipt Information{" "}
                                                  </span>
                                                </p>
                                                <p>
                                                  Please provide information to display on the receipt and
                                                  invoice.
                                                </p>
                                                <Button
                                                  className="blue-button text-white "
                                                  onClick={handleUpdateReceiptClick}
                                                >
                                                  Add Receipt Information
                                                </Button>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                        {/* Modal for updating receipt information */}
                                        <Modal
                                          show={showReceiptModal}
                                          onHide={() => setShowReceiptModal(false)}
                                        >
                                          <Modal.Header closeButton>
                                            <Modal.Title>Update Receipt Information</Modal.Title>
                                          </Modal.Header>

                                          <Modal.Body>
                                            <p className="campaignBoxName">
                                              Address
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={address || ""} // Ensure state is set correctly
                                                onChange={(e) => setAddress(e.target.value)}
                                              />
                                            </p>

                                            <p className="campaignBoxName">
                                              Phone Number
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={phoneNo || ""}
                                                onChange={(e) => setPhoneNo(e.target.value)}
                                              />
                                            </p>

                                            <p className="campaignBoxName">
                                              Tagline 1
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={tagLine1 || ""}
                                                onChange={(e) => setTagLine1(e.target.value)}
                                              />
                                            </p>

                                            <p className="campaignBoxName">
                                              Tagline 2
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={tagLine2 || ""}
                                                onChange={(e) => setTagLine2(e.target.value)}
                                              />
                                            </p>

                                            <p className="campaignBoxName">
                                              Watermark 1
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={watermark1 || ""}
                                                onChange={(e) => setWatermark1(e.target.value)}
                                              />
                                            </p>

                                            <p className="campaignBoxName">
                                              Watermark 2
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={watermark2 || ""}
                                                onChange={(e) => setWatermark2(e.target.value)}
                                              />
                                            </p>

                                            <p className="campaignBoxName">
                                              GST
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={gstnum || ""}
                                                onChange={(e) => setGstNum(e.target.value)}
                                              />
                                            </p>
                                          </Modal.Body>
                                          <Modal.Footer>
                                            <Button
                                              variant="secondary"
                                              onClick={() => setShowReceiptModal(false)}
                                            >
                                              Cancel
                                            </Button>
                                            <Button variant="primary" onClick={handleSaveReceiptChanges}>
                                              Save Changes
                                            </Button>
                                          </Modal.Footer>
                                        </Modal>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div> </>}


            </div>
          </div>
        </div>
      </></div>
  )
}

export default AdminOrdersSetting